module.exports = __webpack_public_path__ + "img/mrt.a46829f1.svg";